import { render, staticRenderFns } from "./KeyFeedbackEditList.vue?vue&type=template&id=653e244c&scoped=true"
import script from "./KeyFeedbackEditList.vue?vue&type=script&lang=js"
export * from "./KeyFeedbackEditList.vue?vue&type=script&lang=js"
import style0 from "./KeyFeedbackEditList.vue?vue&type=style&index=0&id=653e244c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653e244c",
  null
  
)

export default component.exports